import React, { FC } from 'react';

import cn from 'classnames';

interface Props {
  isOn: boolean;
  classNames?: string;
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => any;
}

const ToggleSwitch: FC<Props> = ({ isOn, classNames, onClick }) => {
  return <div className={cn('toggle-switch', classNames, { 'toggle-switch--on': isOn })} onClick={onClick} />;
};

export default ToggleSwitch;
